import type React from 'react'
import { FormattedMessage } from 'react-intl'

import { IndeterminateProgressBar } from '@/components/atoms/IndeterminateProgressBar/IndeterminateProgressBar.tsx'

export const AppLoading: React.FC = () => (
  <div className="flex h-screen flex-col items-center justify-center gap-4 px-8">
    <p className="text-lg text-gray-600">
      <FormattedMessage id="app.loading" />
    </p>
    <IndeterminateProgressBar className="max-w-xs" />
  </div>
)
